import { Button, Icon } from '@britishcouncil/react-admin';
import { Time } from '@britishcouncil/react-common';
import styled from '@emotion/styled';
import { LrwSessionDto } from 'api/planning';
import { SessionStatusBadge, DayOfTheWeekBadge } from 'components';
import { ROUTING_PATHS } from 'const';
import { generatePath, useNavigate } from 'react-router';
import { Column } from 'react-table';
import { OnComputerWritingFormatBadges } from '../details/OnComputerWritingFormatsBadges';
const { lrwSessionDetails } = ROUTING_PATHS;

export const columns: Column<LrwSessionDto>[] = [
  {
    Header: 'Date',
    accessor: 'date',
    Cell: (x) => (
      <S.SpacedContainer>
        <DayOfTheWeekBadge date={x.value} />
        {x.value}
      </S.SpacedContainer>
    ),
    width: '140px',
  },
  {
    Header: 'Venue',
    accessor: 'venue',
    width: 'auto',
  },
  {
    Header: 'Time',
    accessor: 'id',
    Cell: ({ row }) =>
      `${Time.fromString(row.original.startTime)} - ${Time.fromString(row.original.endTime)}`,
    width: '100px',
    disableSortBy: true,
  },
  {
    Header: 'Registrations',
    accessor: 'numberOfRegistrations',
    width: 'auto',
    disableSortBy: true,
  },
  {
    Header: 'Selected rooms',
    accessor: 'numberOfAssignedRooms',
    width: 'auto',
    disableSortBy: true,
  },
  {
    Header: 'Writing format',
    accessor: 'onComputerWritingFormats',
    Cell: ({ value }) => <OnComputerWritingFormatBadges onComputerWritingFormats={value} />,
    width: '100px',
    disableSortBy: true,
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }) => (
      <SessionStatusBadge
        status={row.original.status}
        hasLinkedSession={!!row.original.linkedSpeakingSessionId}
      />
    ),
    width: '120px',
    disableSortBy: true,
  },
  {
    Header: '',
    id: 'actions',
    accessor: 'id',
    Cell: ({ value }) => {
      const navigate = useNavigate();
      return (
        <S.Button
          onClick={() =>
            navigate(generatePath(lrwSessionDetails.absolutePath, { sessionId: value }))
          }
          data-testid="view-lrw-session-button"
        >
          <Icon name="angle right" size="large" color="blue" />
        </S.Button>
      );
    },
    disableSortBy: true,
    width: '0',
  },
];

const S = {
  SpacedContainer: styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `,
  Button: styled(Button)`
    &.ui.button {
      background-color: transparent;
      padding: 2px 4px;
      & > i.icon {
        margin: 0 !important;
      }
    }
  `,
};
